(() => {
  const dialog = document.querySelector('.cart-editorial__confirm');
  if (!dialog) return;
  let opener, clearing = false, closing = false;
  async function closeDialog(confirm = false) {
    if (!dialog.open || closing) return;
    closing = true;
    dialog.classList.add('is-closing');
    if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const animations = dialog.getAnimations({ subtree: true });
      await Promise.race([
        Promise.all(animations.map(animation => animation.finished.catch(() => {}))),
        new Promise(resolve => setTimeout(resolve, 240)),
      ]);
    }
    dialog.close();
    dialog.classList.remove('is-closing');
    closing = false;
    if (confirm) clearCart();
  }
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-clear-cart]');
    if (!button || clearing || button.disabled || document.querySelector('.cart-items-disabled')) return;
    event.preventDefault();
    if (dialog.open) return;
    opener = button;
    removeTrapFocus();
    dialog.showModal();
    dialog.querySelector('[data-cancel-clear]').focus();
  });
  dialog.addEventListener('close', () => {
    const drawer = opener?.closest('cart-drawer.active');
    if (drawer) trapFocus(drawer.querySelector('.drawer__inner'), opener);
    else if (opener?.isConnected) opener.focus();
  });
  dialog.addEventListener('cancel', (event) => {
    event.preventDefault();
    closeDialog();
  });
  dialog.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    event.preventDefault();
    event.stopPropagation();
    closeDialog();
  });
  dialog.addEventListener('click', (event) => {
    if (event.target.closest('[data-confirm-clear]')) {
      closeDialog(true);
    } else if (event.target.closest('[data-cancel-clear]')) {
      closeDialog();
    } else if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDialog();
    }
  });
  async function clearCart() {
    if (clearing) return;
    clearing = true;
    const drawer = document.querySelector('cart-drawer');
    const pageCart = document.querySelector('cart-items');
    const sections = !pageCart && drawer ? drawer.getSectionsToRender().map(section => section.id) : [];
    const controls = [...document.querySelectorAll('[data-clear-cart], cart-items input, cart-items button, cart-drawer-items input, cart-drawer-items button, [name="checkout"]')].filter(control => !control.disabled);
    controls.forEach(control => { control.disabled = true; });
    opener?.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(`${routes.cart_url}/clear.js`, {
        ...fetchConfig(),
        body: JSON.stringify({ sections, sections_url: window.location.pathname }),
      });
      const cart = await response.json();
      if (!response.ok || cart.errors || cart.item_count !== 0) throw new Error('Unable to clear cart');
      if (pageCart || !drawer || sections.some(section => !cart.sections?.[section])) {
        window.location.reload();
        return;
      }
      drawer.renderContents(cart);
      drawer.classList.add('is-empty');
      const empty = drawer.querySelector('.drawer__inner-empty');
      if (drawer.classList.contains('active') && empty) trapFocus(empty, empty.querySelector('a.button'));
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: cart });
    } catch (error) {
      const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      if (errors) errors.textContent = window.cartStrings.error;
    } finally {
      clearing = false;
      opener?.removeAttribute('aria-busy');
      controls.forEach(control => { control.disabled = false; });
    }
  }
})();
